export const getIneligiblesForAsset = (asset, ineligibles) => {
  if (!asset.ineligibles || !asset.ineligibles.length) {
    return []
  }
  return asset.ineligibles.map((ineligibleId) => {
    return ineligibles[ineligibleId]
  })
}

const calculateEligibleAmount = (asset, ineligibles, field) => {
  if (!asset || !asset[field]) {
    return 0
  }
  const assetInelegibles = getIneligiblesForAsset(asset, ineligibles)
  let totalEligible = asset[field]
  assetInelegibles.forEach((ineligible) => {
    totalEligible -= ineligible[field]
  })
  return totalEligible
}

export const calculateLastTotalEligible = (asset, ineligibles) => {
  return calculateEligibleAmount(asset, ineligibles, 'last_value')
}

export const calculateTotalEligible = (asset, ineligibles) => {
  return calculateEligibleAmount(asset, ineligibles, 'value')
}

export const calculateTotalMargined = (eligibleTotal, advanceRate) => {
  return eligibleTotal * advanceRate
}

export const parseNumber = (value) => {
  if (value) {
    return Number(value.replace(/[^0-9.-]+/g, ''))
  } else {
    return 0
  }
}
